import React from "react";
import { Form } from "react-bootstrap";
import { TStepLegsOption, TStepRangesOption, TStepsOption } from "../../../../../api/endpoints/SubsetOption";
import Footnote from "../../../Footnote";
import ForecastStepsSelector from "../../../ForecastStepsSelector";
import FormError from "../../../FormError";
import { FormikProductFormField, TFormErrorMessage } from "../../index";

interface Props extends FormikProductFormField {
  spec: TStepLegsOption | TStepsOption | TStepRangesOption;
}

const ForecastStepsField = (props: Props) => {
  const { formik, spec } = props;

  return (
    <Form.Group controlId="forecastSteps">
      <Form.Label>Forecast time steps</Form.Label>

      <ForecastStepsSelector
        spec={spec}
        values={formik.values.steps}
        onChange={(values: Array<string>) => formik.setFieldValue('steps', values)}
      />

      <FormError message={formik.errors.steps as TFormErrorMessage}
                 when={formik.touched.steps && Boolean(formik.errors.steps)} />

      <Footnote text={spec.footnote} />
    </Form.Group>
  )
}

export default ForecastStepsField;
